import { render, staticRenderFns } from "./ArticlesHome.vue?vue&type=template&id=080a18e2&scoped=true"
import script from "./ArticlesHome.vue?vue&type=script&lang=js"
export * from "./ArticlesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a18e2",
  null
  
)

export default component.exports